/* eslint-disable */
/* eslint-disable no-restricted-syntax */
/* eslint-disable object-shorthand */

// react imports
import { useState } from "react";

// @mui material components
import { Divider, Radio } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// notistack imports
import { useSnackbar } from "notistack";

// Context imports
import { useMaterialUIController, setPageState } from "context";

// Firebase imports
import { doc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../../../../../../Firebase";

function AddAddress() {
  const [, dispatch] = useMaterialUIController();

  const auth = getAuth();
  const user = auth.currentUser;

  const { enqueueSnackbar } = useSnackbar();

  const [country, setCountry] = useState("");
  const [countryError, setCountryError] = useState(false);
  const [isInternational, setIsInternational] = useState("United States");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState(false);
  const [attn, setAttn] = useState("");
  const [nickName, setNickName] = useState("");
  const [attnError, setAttnError] = useState(false);
  const [nickNameError, setNickNameError] = useState(false);
  const [clinic, setClinic] = useState("");
  const [clinicError, setClinicError] = useState(false);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine1Error, setAddressLine1Error] = useState(false);
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [city, setCity] = useState("");
  const [cityError, setCityError] = useState(false);
  const [state, setState] = useState("");
  const [stateError, setStateError] = useState(false);
  const [zip, setZip] = useState("");
  const [zipError, setZipError] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const saveAddress = async () => {
    if (!user) {
      enqueueSnackbar("You must be logged in to save an address", {
        variant: "error",
        autoHideDuration: 3000,
      });
      return;
    }

    if (country === undefined) {
      return;
    }

    let hasErrors = false;

    if (nickName === "") {
      setNickNameError(true);
      hasErrors = true;
    }

    if (attn === "") {
      setAttnError(true);
      hasErrors = true;
    }

    if (email === "") {
      setEmailError(true);
      hasErrors = true;
    }

    if (phone === "") {
      setPhoneError(true);
      hasErrors = true;
    }

    if (clinic === "") {
      setClinicError(true);
      hasErrors = true;
    }

    if (addressLine1 === "") {
      setAddressLine1Error(true);
      hasErrors = true;
    }

    if (city === "") {
      setCityError(true);
      hasErrors = true;
    }

    if (state === "") {
      setStateError(true);
      hasErrors = true;
    }

    if (zip === "") {
      setZipError(true);
      hasErrors = true;
    }

    if (country === "") {
      setCountryError(true);
      hasErrors = true;
    }

    if (hasErrors) {
      enqueueSnackbar("Please fill in all required fields", {
        variant: "warning",
        autoHideDuration: 2000,
      });
      return;
    }

    setIsSaving(true);

    try {
      const shippingAddress = {
        nickName: nickName,
        email: email,
        phone: phone,
        attn: attn,
        country: country,
        clinic: clinic,
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        addressLine3: addressLine3,
        city: city,
        state: state,
        zip: zip,
        createdAt: new Date().toISOString(),
        userId: user.uid,
      };

      const userAddressRef = doc(db, "USERS", user.uid, "ADDRESSES", nickName);

      await setDoc(userAddressRef, shippingAddress);

      enqueueSnackbar(`${nickName} has been added to your Address Book!`, {
        variant: "success",
        autoHideDuration: 2000,
      });
      setPageState(dispatch, "AddressBook");
    } catch (error) {
      console.error("Error saving address:", error);
      
      let errorMessage = "Failed to save address. Please try again.";
      
      if (error.code === "permission-denied") {
        errorMessage = "You don't have permission to save this address. Please check your account status.";
      } else if (error.code === "unauthenticated") {
        errorMessage = "You must be logged in to save an address.";
      }
      
      enqueueSnackbar(errorMessage, {
        variant: "error",
        autoHideDuration: 3000,
      });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <MDBox p={2}>
      <MDBox p={2}>
        {nickNameError && (
          <MDTypography variant="caption" color="error">
            Please enter a nick name for this address.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Nick Name"
          value={nickName}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setNickName(e.target.value);
            setNickNameError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        {attnError && (
          <MDTypography variant="caption" color="error">
            Please enter an ATTN to.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Attention to"
          value={attn}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAttn(e.target.value);
            setAttnError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        {emailError && (
          <MDTypography variant="caption" color="error">
            Please enter an email address.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setEmailError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        {phoneError && (
          <MDTypography variant="caption" color="error">
            Please enter a phone number.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Phone #"
          value={phone}
          onChange={(e) => {
            setPhone(e.target.value);
            setPhoneError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        <MDTypography variant="caption">Select Country:</MDTypography>
        <Radio
          checked={country === "United States"}
          onChange={(e) => {
            setCountry(e.target.value);
            setCountryError(false);
            setIsInternational(false);
          }}
          value="United States"
          name="radio-buttons"
          inputProps={{ "aria-label": "United States" }}
        />
        <MDTypography variant="caption">United States</MDTypography>
        <Radio
          checked={country !== "United States"}
          onChange={() => {
            setCountry("");
            setIsInternational(true);
          }}
          value="International"
          name="radio-buttons"
          inputProps={{ "aria-label": "International" }}
        />
        <MDTypography variant="caption">International</MDTypography>
      </MDBox>
      <MDBox p={2}>
        {countryError && (
          <MDTypography variant="caption" color="error">
            Please enter a Country.
          </MDTypography>
        )}
        {isInternational && (
          <MDInput
            type="text"
            label="Country Name"
            value={country}
            inputProps={{ maxLength: 35 }}
            onChange={(e) => {
              setCountry(e.target.value);
              setCountryError(false);
            }}
            style={{ width: "100%" }}
            required
          />
        )}
      </MDBox>
      <MDBox p={2}>
        {clinicError && (
          <MDTypography variant="caption" color="error">
            Please enter a clinic name.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Clinic/Company Name"
          value={clinic}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setClinic(e.target.value);
            setClinicError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        {addressLine1Error && (
          <MDTypography variant="caption" color="error">
            Please enter an address.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Address Line 1"
          value={addressLine1}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAddressLine1(e.target.value);
            setAddressLine1Error(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        <MDInput
          type="text"
          label="Address Line 2"
          value={addressLine2}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAddressLine2(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        <MDInput
          type="text"
          label="Address Line 3"
          value={addressLine3}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setAddressLine3(e.target.value);
          }}
          style={{ width: "100%" }}
        />
      </MDBox>
      <MDBox p={2}>
        {cityError && (
          <MDTypography variant="caption" color="error">
            Please enter a city.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="City"
          value={city}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setCity(e.target.value);
            setCityError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        {stateError && (
          <MDTypography variant="caption" color="error">
            Please enter a State/Province.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="State/Province"
          value={state}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setState(e.target.value);
            setStateError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <MDBox p={2}>
        {zipError && (
          <MDTypography variant="caption" color="error">
            Please enter a postal code.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Postal Code"
          value={zip}
          inputProps={{ maxLength: 35 }}
          onChange={(e) => {
            setZip(e.target.value);
            setZipError(false);
          }}
          style={{ width: "100%" }}
          required
        />
      </MDBox>
      <Divider />
      <MDBox p={2}>
        <MDButton
          variant="contained"
          color="info"
          sx={{ mb: "1rem" }}
          onClick={saveAddress}
          fullWidth
          disabled={isSaving}
        >
          {isSaving ? "Saving..." : "Save Address To Address Book"}
        </MDButton>
      </MDBox>
    </MDBox>
  );
}

export default AddAddress;
